import React from 'react';

const SetTitle = ({ styles }) => {
  return <div className={styles.SetTitle}>SetTitle</div>;
};

export default SetTitle;
